import React from 'react';
import { Checkbox } from "../../../../components/Checkbox/Checkbox";
import { Typography } from "../../../../components/Typography/Typography";
import { makeStyles } from "../../../../styles/index";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        display: 'flex',
        alignItems: 'center',
        boxSizing: 'border-box',
        width: '100%',
        height: 'auto',
        minHeight: 48,
        position: 'relative',
        transition: theme.transitions.duration.shorter + "ms",
    },
    title: {
        flex: '1 0 0%',
        display: 'flex',
        marginLeft: theme.spacing(7),
        alignItems: 'center',
    },
    checkbox: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(1, 2),
    },
}); }, { name: 'SnWorkTemplate' });
export var WorkTemplate = function (_a) {
    var _b = _a.model, name = _b.name, selected = _b.selected, remainingCount = _a.remainingCount, onClickCheckbox = _a.onClickCheckbox, onClickWorkTemplate = _a.onClickWorkTemplate;
    var classes = useStyles();
    var handleClickCheckboxContainer = function (event) {
        // チェックボックス近傍の領域をクリックしたとき、onClickWorkTemplateを発動しないようにする。
        // チェックボックスをクリックしようとして少しズレたときに、onClickWorkTemplateが発動して
        // 別タブでプレビューが開くとユーザビリティ上好ましくないため。
        event.stopPropagation();
    };
    return (React.createElement("div", { className: classes.root, onClick: onClickWorkTemplate },
        React.createElement("div", { className: classes.title },
            React.createElement(Typography, { variant: "body1" }, name)),
        React.createElement("div", { className: classes.checkbox, onClick: handleClickCheckboxContainer },
            React.createElement(Checkbox, { disabled: remainingCount === 0 && !selected, value: selected, onClick: onClickCheckbox }))));
};
